import $ from "jquery";
import Helpers from "../utilities/helpers";
import AJAXForm from "../components/AJAXForm";

export default function ContactUs() {
    $( initContactUs );
    // $( initContactForm );
}

/**
 * Initialise the contact us page contact form.
 */
async function initContactForm() {
    $("#contact-form").on("submit", function (e) {
        e.preventDefault(); // Prevent default form submission

        // Get reCAPTCHA response
        const recaptchaResponse = grecaptcha.getResponse();
        if (recaptchaResponse.length === 0) {
            $("#form-result").removeClass("text-green-500 hidden").addClass("text-red-500").text("Please complete the reCAPTCHA.");
            return;
        }

        // Prepare form data including reCAPTCHA response
        const formData = new FormData(this);
        formData.append("g-recaptcha-response", recaptchaResponse);

        // Submit the form via AJAX
        fetch($(this).attr("action"), {
            method: "POST",
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-Requested-By': 'AjaxForm'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === "error") {
                    $("#form-result").removeClass("text-green-500 hidden").addClass("text-red-500").text("Something went wrong while recording your query. Please try again later.");
                } else {
                    $("#form-result").removeClass("text-red-500 hidden").addClass("text-green-500").text("Your query has been received.");
                }
            })
            .catch(() => {
                $("#form-result").removeClass("text-green-500 hidden").addClass("text-red-500").text("Something went wrong while recording your query. Please try again later.");
            });
    });
    // Initialise the AJAX form.
    const ajaxForm = new AJAXForm( "contact-form" );
    ajaxForm.handleSuccess(function (data) {
        if (data.status === "error") {
            $("#form-result").removeClass("text-green-500 hidden").addClass("text-red-500").text("Something went wrong while recording your query. Please try again later.");
            grecaptcha.reset();
        } else {
            $("#form-result").removeClass("text-red-500 hidden").addClass("text-green-500").text("Your query has been received.");
            grecaptcha.reset();
        }
        $("#contact-form")[0].reset(); // Reset form fields
        $("#contact-form button[type='submit']").prop("disabled", false);
    });

    // Set event handler for failed post (unvalidated inputs).
    ajaxForm.handleInvalid(function () {
        $("#form-result").removeClass("text-green-500 hidden").addClass("text-red-500").text("Please fill in all fields.");
        grecaptcha.reset();
        $("#contact-form")[0].reset(); // Reset form fields
        $("#contact-form button[type='submit']").prop("disabled", false);
    });

    // Add custom form submission handler

}

/**
 * Initialise the contact us page.
 */
async function initContactUs() {
    // Get Google Cloud console API Key (which must be tied to YouTube API) & the channel ID.
    const apiKey = Helpers.vlConfig( "youtube_api_key" );
    const channelKey = Helpers.vlConfig( "youtube_channel_key" );

    if ( ( ! apiKey ) || ( ! channelKey ) ) {
        return;
    }

    // Search on the IFG channel.
    const searchResponse = await Helpers.searchYouTube( apiKey, {
        part:       "snippet",
        channelId:  channelKey,
        maxResults: 1,
        order:      "date",
        type:       "video"
    } );

    // Ensure there is a result.
    if ( ( ! searchResponse ) || ( ! searchResponse.items ) || ( ! searchResponse.items.length ) ) {
        return;
    }

    // The first, and what should be the only, result.
    const searchResult = searchResponse.items[ 0 ];

    if ( searchResult ) {
        // Set the background image of the clickable button.
        $( "#youtube-thumbnail" ).css( {
            "background-image": `url( "${ searchResult.snippet.thumbnails.high.url }" )`
        } );

        // Make the click event open the specified video in a new tab.
        $( "#youtube-open" ).off( "click" ).on( "click", function () {
            window.open( `https://www.youtube.com/watch?v=${ searchResult.id.videoId }`, "_blank" );
        } );
    }
}